import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CloudDownload, Loader2, Store } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { DEFAULT_CLOUD_URL, IS_DESKTOP } from "../lib/desktop";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { PasswordInput } from "./ui/password-input";
import { Label } from "./ui/label";

export const LinkCloudForm = ({ allowRegister = false, initialUrl, onDone }) => {
  const [mode, setMode] = useState("login");
  const [f, setF] = useState({ cloud_url: initialUrl || DEFAULT_CLOUD_URL, username: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/desktop/sync/link", { ...f, mode });
      onDone?.(data);
    } catch (e2) {
      setErr(errMsg(e2));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="link-cloud-form">
      {allowRegister && (
        <div className="grid grid-cols-2 gap-2 text-sm">
          {[["login", "Masuk akun cloud"], ["register", "Daftarkan toko ini ke cloud"]].map(([k, l]) => (
            <button type="button" key={k} onClick={() => setMode(k)} data-testid={`link-mode-${k}`}
              className={`rounded-lg border px-3 py-2 transition-colors ${mode === k ? "border-primary bg-primary/10 font-semibold" : ""}`}>{l}</button>
          ))}
        </div>
      )}
      <div className="space-y-1.5">
        <Label>Alamat server cloud</Label>
        <Input value={f.cloud_url} onChange={(e) => setF({ ...f, cloud_url: e.target.value })} required data-testid="link-cloud-url-input" />
      </div>
      {mode === "login" && (
        <div className="space-y-1.5">
          <Label>Email / username owner (cloud)</Label>
          <Input value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} required data-testid="link-username-input" />
        </div>
      )}
      <div className="space-y-1.5">
        <Label>{mode === "login" ? "Password cloud" : "Password owner toko ini"}</Label>
        <PasswordInput value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required data-testid="link-password-input" />
      </div>
      {mode === "register" && <p className="text-xs text-muted-foreground">Toko, produk, dan transaksi di komputer ini akan diunggah ke cloud. Owner dapat login di web/HP dengan email & password yang sama.</p>}
      {err && <div className="text-sm text-destructive bg-destructive/10 rounded-lg px-3 py-2" data-testid="link-error">{err}</div>}
      <Button type="submit" className="w-full" disabled={busy} data-testid="link-submit-btn">
        {busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}Hubungkan & Sinkronkan
      </Button>
    </form>
  );
};

export const DesktopFirstRun = ({ children }) => {
  const [info, setInfo] = useState(null);
  const [linking, setLinking] = useState(false);
  useEffect(() => { if (IS_DESKTOP) api.get("/desktop/info").then(({ data }) => setInfo(data)).catch(() => setInfo({ has_users: true })); }, []);
  if (!IS_DESKTOP || info?.has_users !== false) return children;
  return (
    <div className="w-full max-w-sm space-y-6 fade-up" data-testid="desktop-first-run">
      <div>
        <h1 className="font-display text-3xl font-extrabold tracking-tight">Selamat datang</h1>
        <p className="text-muted-foreground mt-1 text-sm">Data toko akan tersimpan di komputer ini dan tetap bisa dipakai tanpa internet.</p>
      </div>
      {linking ? (
        <>
          <LinkCloudForm onDone={() => setInfo({ has_users: true })} />
          <button className="text-sm text-muted-foreground hover:underline" onClick={() => setLinking(false)} data-testid="first-run-back">Kembali</button>
        </>
      ) : (
        <div className="space-y-3">
          <Button asChild className="w-full h-12 justify-start" data-testid="first-run-new-store"><Link to="/daftar"><Store className="h-5 w-5 mr-3" />Buat toko baru di komputer ini</Link></Button>
          <Button variant="outline" className="w-full h-12 justify-start" onClick={() => setLinking(true)} data-testid="first-run-link-cloud">
            <CloudDownload className="h-5 w-5 mr-3" />Sudah punya akun cloud? Ambil data toko
          </Button>
        </div>
      )}
    </div>
  );
};
